import { createFileRoute, redirect } from "@tanstack/react-router";
import { withQuery } from "@/lib/redirect-query";

// Legacy URL — permanently redirect to the results page.
export const Route = createFileRoute("/danny-kanell")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: withQuery("/results/", location.searchStr), statusCode: 301 });
  },
});
